import { render, staticRenderFns } from "./catCodeEdit.vue?vue&type=template&id=37a3da5e&scoped=true"
import script from "./catCodeEdit.vue?vue&type=script&lang=js"
export * from "./catCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./catCodeEdit.vue?vue&type=style&index=0&id=37a3da5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3da5e",
  null
  
)

export default component.exports